import { shouldShowPayAtPropertyPill } from '../utils'

interface PayAtPropertyChoiceParams {
  isPropertyCollectEnabled: boolean
  hasFlight: boolean
  relatedPayAtPropertyRate?: App.BedbankRate
}

interface PayAtPropertyVisibilityParams {
  isPropertyCollectEnabled: boolean
  flightsBookingActive: boolean
  rate: App.BedbankRate
  relatedPayAtPropertyRate?: App.BedbankRate
}

export function shouldOfferBedbankPayAtPropertyChoice({
  isPropertyCollectEnabled,
  hasFlight,
  relatedPayAtPropertyRate,
}: PayAtPropertyChoiceParams): boolean {
  return isPropertyCollectEnabled && !hasFlight && !!relatedPayAtPropertyRate
}

interface BedbankFlightBookingStateParams {
  flightsEnabled: boolean
  hasFlightOrigin: boolean
  isFlightsSelected: boolean
}

/**
 * The real tile's flight-bundle-toggle gates: pay-at-property is hidden while a flight-bundled
 * booking is active (`flightsBookingActive`), and the hotel-only price block (which pay-later
 * gates on) is hidden whenever flights are enabled and selected at all (`hideHotelPriceBlock`),
 * regardless of a specific flight origin.
 */
export function getBedbankFlightBookingState({
  flightsEnabled,
  hasFlightOrigin,
  isFlightsSelected,
}: BedbankFlightBookingStateParams): { flightsBookingActive: boolean, hideHotelPriceBlock: boolean } {
  return {
    flightsBookingActive: flightsEnabled && hasFlightOrigin && isFlightsSelected,
    hideHotelPriceBlock: flightsEnabled && isFlightsSelected,
  }
}

export function getBedbankPayAtPropertyVisibility({
  isPropertyCollectEnabled,
  flightsBookingActive,
  rate,
  relatedPayAtPropertyRate,
}: PayAtPropertyVisibilityParams) {
  return {
    canPayAtProperty: isPropertyCollectEnabled && !flightsBookingActive && shouldShowPayAtPropertyPill(rate),
    hasRelatedPayAtPropertyRate: isPropertyCollectEnabled && !!relatedPayAtPropertyRate,
  }
}
